import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {SimplePresentation, SimplePresentationRunner} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheCrypt} from "../../TheCrypt";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {FreespinIntroPresentation} from "../../presentations/maingame/FreespinIntroPresentation";
import {TheCryptHelper} from "../../utils/TheCryptHelper";
import {UpgradeCollectorPresentation} from "../../presentations/freespin/UpgradeCollectorPresentation";
import {CollapsePresentation} from "../../presentations/maingame/CollapsePresentation";
import {DropOutPresentation} from "../../presentations/maingame/DropOutPresentation";
import {ScatterCounter} from "../../view/ScatterCounter";

export class TheCryptFSIdlePresentation implements FlowStatePresentation {
    private _flowStateController: FlowStateController;
    private readonly _presentations: SimplePresentation[];

    constructor() {
        this._presentations = [
            new FreespinIntroPresentation(),
            new CollapsePresentation(),
            new DropOutPresentation(),
            new UpgradeCollectorPresentation(),
        ]
    }

    start(flowStateController: FlowStateController): void {
        this._flowStateController = flowStateController;
        if (TheCrypt.model.isRestore) {
            ScatterCounter.onRestore();
            TheCrypt.reelFrame.updateWays(TheCrypt.model.initData.totalNumberOfWays);
            if (TheCrypt.model.initData.accumulatedRoundWin > 0) {
                TheCrypt.keypadPlugin.setWin(TheCrypt.model.initData.accumulatedRoundWin, true, TheCryptHelper.isWinBelowStake());
            }
        }
        SimplePresentationRunner.run(this._presentations, () => this.complete(), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }

    public complete() {
        const addedNumberOfFreespinsThisSpin:number = (TheCrypt.model.isRestore?0:TheCrypt.model.data.addedNumberOfFreespinsThisSpin);
        let fsLeft:number = TheCrypt.model.freespinsLeft - 1 - addedNumberOfFreespinsThisSpin;

        if(TheCrypt.model.freespinTriggeredThisSpin || !TheCrypt.model.isNextRespin) {
            TheCrypt.reelFrame.reset();
            fsLeft += (TheCrypt.model.freespinTriggeredThisSpin?addedNumberOfFreespinsThisSpin:0);
            TheCrypt.keypadPlugin.setZeroBetSpinCounter(fsLeft);
        }else if(TheCrypt.model.isRestore){
            TheCrypt.reelFrame.reset();
            fsLeft += 1;
            TheCrypt.keypadPlugin.setZeroBetSpinCounter(fsLeft);
            //console.log("fsleft idle restore:"+fsLeft)
        }

        SlotGame.apiPlugin.betHandler.zeroBet();
        this._flowStateController.finish();
    }
}